(() => {
  const currentScript = document.currentScript;

  if (!currentScript || !document.querySelector('predictive-search')) return;

  const cssUrl = currentScript.dataset.css;
  const jsUrl = currentScript.dataset.js;
  let loaded = false;
  let loadingPromise;

  const loadStylesheet = () => {
    if (!cssUrl || document.querySelector(`link[href="${cssUrl}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    document.head.appendChild(link);
  };

  const loadScript = () => {
    if (!jsUrl) return Promise.resolve();
    if (customElements.get('predictive-search') || document.querySelector(`script[src="${jsUrl}"]`)) {
      return customElements.whenDefined('predictive-search');
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = jsUrl;
      script.defer = true;
      script.onload = () => customElements.whenDefined('predictive-search').then(resolve);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  const replayActiveSearch = () => {
    const input = document.activeElement;
    if (!input || input.type !== 'search') return;

    const predictiveSearch = input.closest('predictive-search');
    if (!predictiveSearch || !input.value.trim()) return;

    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const loadPredictiveSearch = () => {
    if (loaded) return loadingPromise;
    loaded = true;
    cleanup();
    loadStylesheet();
    loadingPromise = loadScript().then(replayActiveSearch);
    return loadingPromise;
  };

  const events = ['focusin', 'input', 'pointerdown', 'keydown'];
  const options = { capture: true, passive: true };

  function shouldLoad(event) {
    if (event.target?.closest?.('predictive-search')) {
      loadPredictiveSearch();
    }
  }

  function cleanup() {
    events.forEach((eventName) => document.removeEventListener(eventName, shouldLoad, options));
  }

  events.forEach((eventName) => document.addEventListener(eventName, shouldLoad, options));

  if (window.Shopify?.designMode) {
    loadPredictiveSearch();
  }
})();
